import { PipeTransform, Pipe } from '@angular/core';

// This pipe allows use of objects in an ngFor, exposing the key and value
// Can be replaced by the built-in pipe 'keyvalue' if Angular is ever upgraded to >6.0.1
@Pipe({name: 'objectFor'})
export class ObjectForPipe implements PipeTransform {
  transform(value: object, args: string[]): any {
    const keys = [];
    for (const key in value) {
      keys.push({key: key, value: value[key]});
    }
    return keys;
  }
}
